import {
  DIMMED_BLUESIH_BACKGROUND,
  DIMMED_GRAYISH_BACKGROUND,
  FONT_COLOR,
  SECONDARY_BLUE,
  SECONDARY_BLUEISH_FONT_COLOR,
} from '@1stLog-engineering/korpaeraet-eidentiti'
import { Badge, Group, px, rem, Text, useMantineTheme } from '@mantine/core'
import React, { ReactNode } from 'react'

type NewManageDesignHeadingProps = {
  badge: ReactNode
  title: ReactNode
}

const NewManageDesignHeading = ({
  badge,
  title,
}: NewManageDesignHeadingProps): React.ReactElement => {
  const theme = useMantineTheme()
  return (
    <Group
      mb={rem(20)}
      p={rem(4)}
      style={{
        borderBottom: `${rem(1)} solid ${FONT_COLOR}`,
      }}
    >
      {badge && (
        <Badge
          styles={{
            root: {
              backgroundColor: setAlpha(FONT_COLOR, 0.75),
              color: 'white',
            },
            inner: {
              color: 'white',
              fontSize: rem(16),
              fontWeight: 500,
              borderRadius: rem(16),
            },
          }}
          color="white"
        >
          {badge}
        </Badge>
      )}
      <Text
        data-testid="card_title"
        style={{
          fontWeight: 500,
          // color: theme.colors.gray[4],
          fontSize: '1rem',
        }}
      >
        {title}
      </Text>
    </Group>
  )
}

export default NewManageDesignHeading

const setAlpha = (rgbaString: string, newAlpha: number): string => {
  const lastCommaIndex = rgbaString.lastIndexOf(',')
  return rgbaString.slice(0, lastCommaIndex + 1) + ' ' + newAlpha + ')'
}
